import { roleToLabel } from "../../shared/pipes/role-label.util";

import type { INormalizedClaims } from "../models/auth.model";
import type { IUserProfile } from "../models/i-user-profile";

const ROLE_PRIORITY: readonly string[] = ["ct-admin", "sp-owner", "sp-admin", "sp-employee"];
const EMPTY: IUserProfile = { displayName: "", initials: "", primaryRoleLabel: "" };

function deriveDisplayName(claims: INormalizedClaims): string {
  if (claims.givenName && claims.familyName) {
    return `${claims.givenName} ${claims.familyName}`;
  }
  return claims.name ?? claims.email ?? "";
}

function deriveInitials(claims: INormalizedClaims): string {
  if (claims.givenName && claims.familyName) {
    return (claims.givenName[0] + claims.familyName[0]).toUpperCase();
  }
  const source = claims.name ?? claims.email ?? "";
  if (!source) {
    return "";
  }
  const at = source.indexOf("@");
  const base = at > 0 ? source.slice(0, at) : source;
  const parts = base.trim()
.split(/\s+/)
.filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  const single = parts[0] ?? "";
  return single.slice(0, 2)
.toUpperCase();
}

function derivePrimaryRoleLabel(roles: readonly string[]): string {
  for (const role of ROLE_PRIORITY) {
    if (roles.includes(role)) {
      return roleToLabel(role);
    }
  }
  return roles.length > 0 ? roleToLabel(roles[0]) : "";
}

export function deriveUserProfile(claims: INormalizedClaims | null): IUserProfile {
  if (!claims) {
    return EMPTY;
  }
  return {
    displayName: deriveDisplayName(claims),
    initials: deriveInitials(claims),
    primaryRoleLabel: derivePrimaryRoleLabel(claims.roles ?? []),
  };
}
